<template>
  <div>
    <main class="container">
      <table-header
        title="Annual Access Review"
        :is-loading="isLoading"
        :is-empty="!AARList.length"
      >
        <template v-if="user.interfaces.includes('UM-AAR-Manage')">
          <button
            class="btn btn-primary-ford-orange white"
            @click="startAAR"
          >
            <i
              v-if="isAARStartLoading"
              class="spinner-border spinner-btn mr-1"
            />
            Запустить AAR
          </button>
          <button
            class="btn btn-primary-ford-orange white"
            @click="checkAAR"
          >
            <i
              v-if="isAARCheckLoading"
              class="spinner-border spinner-btn mr-1"
            />
            Проверить AAR
          </button>
        </template>
      </table-header>
      <div class="table-wrapper">
        <div class="table-container">
          <transition
            name="fade"
            mode="out-in"
          >
            <table
              v-if="!isLoading && AARList.length"
              class="table"
            >
              <thead>
                <tr>
                  <th
                    v-for="header in tableHeaders"
                    :key="header"
                  >
                    <div class="table__header">
                      {{ header }}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="it in AARListFormatted"
                  :key="it.key"
                  class="cursor-pointer"
                  @click="goToAARItem(it.key)"
                >
                  <td>{{ it.key }}</td>
                  <td>{{ it.active }}</td>
                  <td>{{ it.startDate | parseDate }}</td>
                  <td>{{ it.completionDate | parseDate }}</td>
                  <td>{{ it.responsible }}</td>
                  <td>{{ it.users.length }}</td>
                </tr>
              </tbody>
            </table>
          </transition>
        </div>
      </div>
      <table-footer
        v-if="AARList.length && !isLoading"
        :current-page="currentPage"
        :per-page="perPage"
        :limit="limit"
        :total-count="totalCount"
        @pageChanged="page => (currentPage = page)"
        @limitChanged="lim => (limit = lim)"
      />
    </main>
    <b-modal
      v-model="isAARCheckModalShown"
      hide-header
      hide-footer
      centered
      @hide="isAARCheckModalShown = false"
    >
      <form @submit.prevent="sendNotification">
        <div class="modal-header align-items-center">
          <h2
            id="ModalLabel"
            class="modal-title"
          >
            AAR проверен
          </h2>
          <i class="material-icons text-success">check</i>
        </div>
        <div class="modal-body text-success">
          {{ AARCheckMessage }}
        </div>
        <div class="modal-footer">
          <button
            class="btn btn-secondary-ford-gray modal-ext"
            type="button"
            @click="isAARCheckModalShown = false"
          >
            Закрыть
          </button>
          <button
            class="btn btn-primary-ford-orange modal-ext"
            type="submit"
          >
            <i
              v-if="isAARNotificationLoading"
              class="spinner-border spinner-btn mr-1"
            />
            Отправить рассылку
          </button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TableHeader from '@/components/table/TableHeader';
import TableFooter from '@/components/table/TableFooter';

export default {
  name: 'AARList',
  components: {
    TableHeader,
    TableFooter,
  },
  data: () => ({
    isLoading: true,
    isAARCheckModalShown: false,
    AARCheckMessage: '',
    isAARStartLoading: false,
    isAARCheckLoading: false,
    isAARNotificationLoading: false,
    AARList: [],
    tableHeaders: ['Ключ', 'Статус', 'Дата начала', 'Дата завершения', 'Ответственные', 'Пользователей'],
    currentPage: 1,
    perPage: 10,
    limit: 10,
    totalCount: null,
    pageWatcherDisabled: false,
  }),
  computed: {
    ...mapState(['isBackgroundBlurred', 'user']),
    AARListFormatted() {
      return this.AARList.map(it => {
        it.responsible = it.responsible.map(responsible => responsible.email).join(', ');
        it.active = it.active ? 'Активен' : 'Завершен';
        return it;
      });
    },
    pages() {
      return Math.ceil(this.totalCount / this.perPage);
    },
    offset() {
      return this.limit * (this.currentPage - 1);
    },
  },
  watch: {
    limit() {
      this.pageWatcherDisabled = true;
      this.currentPage = 1;
      this.getAARList();
    },
    currentPage() {
      if (this.pageWatcherDisabled) {
        return;
      }

      this.getAARList();
    },
    isAARCheckModalShown(value) {
      this.$store.commit('setBackgroundBlur', value);
    },
  },

  created() {
    this.getAARList();
  },
  methods: {
    async getAARList() {
      this.isLoading = true;
      const { items, total } = await this.$http.get('users/1.0/aar', {
        params: {
          limit: this.limit,
          skip: this.offset,
        },
      });

      this.isLoading = false;

      this.AARList = items;
      this.totalCount = total;
      this.perPage = this.limit;
      this.pageWatcherDisabled = false;
    },
    async startAAR() {
      this.isAARStartLoading = true;
      try {
        const { msg } = await this.$http.put('users/1.0/aar');
        this.$showSuccessMessage(msg);
        this.getAARList();
      } finally {
        this.isAARStartLoading = false;
      }
    },
    async checkAAR() {
      this.isAARCheckLoading = true;
      try {
        const { msg } = await this.$http.post('users/1.0/aar-check');
        this.AARCheckMessage = msg;
        this.isAARCheckModalShown = true;
      } finally {
        this.isAARCheckLoading = false;
      }
    },
    async sendNotification() {
      this.isAARNotificationLoading = true;
      try {
        await this.$http.post('users/1.0/aar-check?notify=true');
        this.isAARCheckModalShown = false;
        this.$showSuccessMessage('Рассылка отправлена');
      } finally {
        this.isAARNotificationLoading = false;
      }
    },
    goToAARItem(key) {
      this.$router.push(`/aar/${key}`);
    },
  },
};
</script>
